import {Component, Input, OnInit} from '@angular/core';
import {IForWhomItem} from './for-whoom-item/for-whoom-item.component';

@Component({
  selector: 'app-for-whoom',
  templateUrl: './for-whoom.component.html',
  styleUrls: ['./for-whoom.component.scss']
})
export class ForWhoomComponent implements OnInit {
  items: IForWhomItem[] = null;
  description = '';
  @Input() type: 'default' | 'business'| 'ai' = 'default';

  constructor() { }

  ngOnInit(): void {
    const data = {
      default:  [
        {
          label: 'Prone to Stress',
          alt: 'Image representing an individual prone to stress',
          src: './assets/img/fh1_1x.webp',
          m_src: './assets/img/fh1_1x.webp',
          link: 'https://blog.anima.help/intense-stress-friend-or-foe/'
        },
        {
          label: 'In Recovery',
          src: 'assets/img/fh2_1x.webp',
          m_src: 'assets/img/fh2_1x.webp',
          alt: 'Image symbolizing a person in therapy going through recovery',
          link: 'https://blog.anima.help/helping-you-to-track-progress/'
        },
        {
          label: 'High-Performer',
          src: 'assets/img/fh3_1x.webp',
          m_src: 'assets/img/fh3_1x.webp',
          alt: 'Image illustrating a high-performer, focusing on achievement and excellence',
          link: 'https://blog.anima.help/trauma-may-be-closer-than-you-think/'

        },
        {
          label: 'Therapist',
          src: 'assets/img/fh4_1x.webp',
          m_src: 'assets/img/fh4_1x.webp',
          alt: 'Image of a therapist, in a counseling setting, emphasizing professionalism and care in mental health.',
          link: 'https://blog.anima.help/how-to-measure-the-effectiveness-of-the-therapy/'

        }
      ],
      business: [
        {
          label: 'Management',
          alt: 'Image representing an individual prone to stress',
          src: './assets/img/for_whoom/management.webp',
          m_src: './assets/img/for_whoom/management.webp',
          link: 'https://blog.anima.help/the-ceos-guide-to-building-a-mentally-healthy-organization/'
        },
        {
          label: 'Human resources',
          src: './assets/img/for_whoom/hr.webp',
          m_src: './assets/img/for_whoom/hr.webp',
          alt: 'Image symbolizing a person in therapy going through recovery',
          link: 'https://blog.anima.help/anima-for-hr-the-next-frontier-in-employee-well-being/'
        },
        {
          label: 'Psychologists',
          src: './assets/img/for_whoom/psy.webp',
          m_src: './assets/img/for_whoom/psy.webp',
          alt: 'Image illustrating a high-performer, focusing on achievement and excellence',
          link: 'https://blog.anima.help/empowering-psychologists-with-smart-tools-for-workplace-wellness/'

        },
        {
          label: 'Employees',
          src: './assets/img/for_whoom/employees.webp',
          m_src: './assets/img/for_whoom/employees.webp',
          alt: 'Image of a therapist, in a counseling setting, emphasizing professionalism and care in mental health.',
          link: 'https://blog.anima.help/take-care-of-yourself-at-work-with-anima/'

        }
      ],
      ai:  [
        {
          label: 'Prone to Stress',
          alt: 'Image representing an individual prone to stress',
          src: './assets/img/fh1_1x.webp',
          m_src: './assets/img/fh1_1x.webp',
          link: 'https://blog.anima.help/intense-stress-friend-or-foe/'
        },
        {
          label: 'In Recovery',
          src: 'assets/img/fh2_1x.webp',
          m_src: 'assets/img/fh2_1x.webp',
          alt: 'Image symbolizing a person in therapy going through recovery',
          link: 'https://blog.anima.help/helping-you-to-track-progress/'
        },
        {
          label: 'High-Performer',
          src: 'assets/img/fh3_1x.webp',
          m_src: 'assets/img/fh3_1x.webp',
          alt: 'Image illustrating a high-performer, focusing on achievement and excellence',
          link: 'https://blog.anima.help/trauma-may-be-closer-than-you-think/'

        },
        {
          label: 'Therapist',
          src: 'assets/img/fh4_1x.webp',
          m_src: 'assets/img/fh4_1x.webp',
          alt: 'Image of a therapist, in a counseling setting, emphasizing professionalism and care in mental health.',
          link: 'https://blog.anima.help/how-to-measure-the-effectiveness-of-the-therapy/'

        }
      ]
    };
    const descriptions = {
      default: 'Our tailored test offers an in-depth evaluation of your emotional state, providing personalized insights. Perfect for anyone interested in understanding themselves better. However, Anima can be especially helpful if you fit into one of the following categories:',
      business: 'Our tailored test provides a comprehensive look at employees’ mental well-being, offering personalized insights that help businesses foster a healthier, more productive workforce. Perfect for organizations of all sizes – whether you’re an HR professional seeking data-driven strategies or a manager looking to support your team. It’s ideal for:',
      ai: 'Whether you\'re feeling overwhelmed, stuck, or simply curious about your inner state, Anima offers science-based insights tailored to your unique attention patterns.<br>' +
          'It’s valuable for anyone interested in mental wellness — but especially helpful if you see yourself in one of the following groups:',
    };
    this.description = descriptions[this.type];
    this.items = data[this.type];
  }
}
